<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li *ngIf="getUserCurrent().company.uniqid === 'admin'" class="breadcrumb-item">
            <a routerLink="/{{getUserCurrent().company.uniqid}}/company">List companies</a>
          </li>
          <li class="breadcrumb-item">
            Client Profile
          </li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div class="pb-2 mb-3 border-bottom">
        <h3>
          <b>{{getPageTitle(service)}} Profile - {{companyName}}</b>
        </h3>
      </div>
      <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
        The market data profile is currently not available.
        <button (click)="error = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="errorExport" class="alert alert-danger alert-dismissible fade show">
        Error while trying to download file
        <button (click)="errorExport = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="errorPopup" class="alert alert-danger alert-dismissible fade show">
        The item data is currently not available.
        <button (click)="errorPopup = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="successCreateJira" class="alert alert-success alert-dismissible fade show">
        Jira ticket number. {{ jiraIssueCode }}  created:
        <a href="{{ jiraLink }}" target="_blank"> jira link </a>
        <button (click)="successCreateJira = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="jiraCreationError" class="alert alert-danger alert-dismissible fade show">
        A JIRA ticket could not be created. You may leave this page open and retry later. We are informing the support.
        <button (click)="jiraCreationError = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="!loading">
        <div class="mb-3 profile-toolbar">
          <div class="toolbar-group toolbar-group--neutral">
            <button pButton label="Select Order Forms" (click)="op.toggle($event)"></button>
            <ng-container *ngIf="!isAlreadyCondensed()">
              <button pButton type="button" label="{{ showFullGrid ? 'Show condensed View' : 'Show Full Grid' }}"
                      (click)="enableFullGrid()"></button>
            </ng-container>
            <button pButton label="Export as XLS" (click)="exportAsExcel()"></button>
          </div>

          <div *ngIf="service !== 'QFD'" class="toolbar-group toolbar-group--info">
            <button (click)="showMulticastGroups()" class="toolbar-btn" type="button">
              <svg fill="none" height="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2.5" viewBox="0 0 24 24" width="14">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
              View multicasts
            </button>
            <button *ngIf="showPopConfigButton" (click)="openConfigPopup()" class="toolbar-btn" type="button">
              <svg fill="none" height="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2" viewBox="0 0 24 24" width="14">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              View POP config
            </button>
          </div>

          <div class="toolbar-group toolbar-group--support">
            <ng-container *ngIf="displayJiraFeature">
              <button (click)="openSendJiraPopup()" class="toolbar-btn" type="button">
                <i class="fa fa-ticket" style="font-size: 12px"></i> Create a support ticket (JIRA)
              </button>
            </ng-container>
            <button pButton label="Legend" (click)="legendPanel.toggle($event)"></button>
          </div>
        </div>
        <p-overlayPanel #op [dismissable]="true" appendTo="body">
          <p-table (onHeaderCheckboxToggle)="onHeaderCheckbox($event)" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                   [(selection)]="selectedOrderForms" [columns]="orderFormsCols"
                   [scrollable]="true" [value]="orderForms" dataKey="identificationNumber" scrollHeight="420px">
            <ng-template let-columns pTemplate="header">
              <tr>
                <th style="width: 3em">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" [style.width]="col.width">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template let-columns="columns" let-rowData pTemplate="body">
              <tr [pSelectableRow]="rowData">
                <td>
                  <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns">
                  {{ rowData[col.field] }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-overlayPanel>
        <p-table [columns]="defaultSelectedCPopCols" [value]="defaultExProducts">
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width:40px">
              <col style="width:70px">
              <col *ngFor="let col of defaultSelectedCPopCols" style="width:20px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th [attr.colspan]="defaultSelectedCPopCols.length + 2" style="text-align: center;">Delivered to:</th>
            </tr>
            <tr>
              <th colspan="2"> Datacenter</th>
              <th *ngFor="let col of defaultSelectedCPopCols" [ngClass]="{'background-grey': isColumnHighlighted(col)}"
                  style="padding-left: 3px;text-align: center; font-size: 9px;">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-exProduct let-rowIndex="rowIndex" pTemplate="body">
            <tr [pSelectableRow]="exProduct">
              <td *ngIf="rowGroupMetadata[exProduct.exchangeName].index === rowIndex  "
                  [attr.rowspan]="rowGroupMetadata[exProduct.exchangeName].size">
                {{ exProduct.exchangeName }}
              </td>
              <td (click)="displayItem($event, exProduct, null, op1)"
                  (mouseleave)="onCellLeave()"
                  (mouseover)="onCellHover(null, rowIndex)"
                  [ngStyle]="{'background-color': isRowHighlighted(rowIndex) ? '#F1EFEB' : 'transparent'}"
                  style="width:auto; white-space: nowrap;">
                {{ exProduct.productName }}
              </td>
              <td (click)="displayItem($event,exProduct,col,op1)" (close)="op1.hide()" (mouseleave)="onCellLeave()"
                  (mouseover)="onCellHover(col,rowIndex)"
                  *ngFor="let col of defaultSelectedCPopCols"
                  [ngClass]="exProduct[col.field] ? getCellClasses(exProduct, col.field) : null"
                  class="no-padding "
                  style="cursor: pointer;">
                <div *ngIf="getIsDisplayed(exProduct,col.field)" style="padding-left: 60%">
                  <ng-container *ngIf="onGoingAnnoucements(exProduct,col.field) && onGoingOutage(exProduct,col.field)">
                    <i class="fa fa-exclamation-circle" style="color: #0d7a8b"></i>
                  </ng-container>
                  <ng-container
                    *ngIf="onGoingAnnoucements(exProduct,col.field) && onGoingMaintenance(exProduct,col.field)  && !onGoingOutage(exProduct,col.field)">
                    <i class="fa fa-wrench" style="color: #0d7a8b"></i>
                  </ng-container>
                  <ng-container
                    *ngIf="onGoingAnnoucements(exProduct,col.field) && !onGoingMaintenance(exProduct,col.field) && !onGoingOutage(exProduct,col.field)">
                    <i class="fa fa-question-circle" style="color: #0d7a8b"></i>
                  </ng-container>
                  <ng-container *ngIf="!onGoingAnnoucements(exProduct,col.field)">
                    {{ exProduct[col.field] ? getCellClasses(exProduct, col.field).substr(0, 1).toUpperCase() : '' }}
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-overlayPanel #op1 [dismissable]="true" [style]="{width: '50%'}" appendTo="body">
          <p-tabView>
            <p-tabPanel *ngFor="let tab of tabData; let i = index" [header]="tab.header" [selected]="i == 0">
              <div class="item-info">
                <p>Status: {{ tab.status }} </p>
                <p>Type: <span id="left-side"><img alt="" src='{{tab.typeImg}}'
                                                   style="width: 5%;"> {{ tab.type }}</span>
                </p>
                <p>Carrier:
                  <span *ngIf="tab.carrier === 'SFI'" style="color: #096547; font-weight: bold;">Streaming Frame Interface</span>
                  <span *ngIf="tab.carrier !== 'SFI'">{{ tab.carrier }}</span>
                </p>
                <p>Hosting: {{ tab.hosting }}</p>
                <p style="line-break: anywhere;">
                  <span *ngIf="tab.crossConnectId || tab.vlanId">Cross-connect ID, VLAN ID: </span>
                  <span *ngIf="tab.crossConnectId">{{ tab.crossConnectId }}</span>
                  <span *ngIf="tab.crossConnectId && tab.vlanId"> | </span>
                  <span *ngIf="tab.vlanId">{{ tab.vlanId }}</span>
                </p>

                <p>Technical POPs:<span [pTooltip]="technicalPopService.getCageTooltip(tab.technicalPop)">{{ tab.technicalPop }} </span></p>
                <button (click)="gotoAnnoucementPage(tab.messagesUuid)" *ngIf="tab.onGoingAnnouncement && tab.onGoingOutage"
                        icon="fa fa-exclamation-triangle" label="Outage" pButton title="Outage"
                        [class]="getClassForCategory(tab.announcementCategory)" type="button"></button>
                <button (click)="gotoAnnoucementPage(tab.messagesUuid)"
                        *ngIf="tab.onGoingAnnouncement && !tab.onGoingOutage"
                        icon="fa fa-question-circle" [label]="getLabelFromAnnouncementCategory(tab.announcementCategory)" pButton [title]="getLabelFromAnnouncementCategory(tab.announcementCategory)"
                        [class]="getClassForCategory(tab.announcementCategory)" type="button"></button>
              </div>
              <div *ngIf="tab.symbols?.length != 0" class="mt-1">
                <p class="item-info">Associated symbols</p>
                <p-table [columns]="symbolsCols" [scrollable]="true" [value]="tab.symbols" scrollHeight="200px">
                  <ng-template let-columns pTemplate="header">
                    <tr>
                      <th *ngFor="let col of columns" [style.width]="col.width">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-columns="columns" let-rowData pTemplate="body">
                    <tr>
                      <td *ngFor="let col of columns" [innerHTML]="rowData[col.field]" [style.width]="col.width"></td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div *ngIf="tab.channels?.length != 0 && service != 'QFD'" class="mt-2">
                <p class="item-info">Associated channels</p>
                  <ng-container *ngIf="service!=='QRD'">
                <p-table [columns]="getChannelsColumns(service, tab.channels[0].layer)" [value]="tab.channels"
                         [scrollable]="true" scrollHeight="200px">
                  <ng-template let-columns pTemplate="header">
                    <tr>
                      <th *ngFor="let col of columns" [style.width]="col.width">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                    <tr>
                      <td *ngIf="isFirstOccurrence(rowIndex, rowData.crossConnectId, tab.channels)"
                          [attr.rowspan]="calculateRowSpan(rowData.crossConnectId, tab.channels)"
                          [style.width]="getColumnWidth(columns, 'crossConnectId')">
                        {{ rowData.crossConnectId }}
                      </td>
                      <ng-container *ngFor="let col of columns">
                        <td [style.width]="col.width"
                          [ngClass]="{
                            'text-green': rowData[col.field] === 'Configured',
                            'text-red': rowData[col.field] === 'Deconfigured',
                            'text-yellow': rowData[col.field] === 'Requested' || rowData[col.field] === 'Config scheduled' || rowData[col.field] === 'New',
                            'text-orange': rowData[col.field] === 'Deconfig requested' || rowData[col.field] === 'Deconfig scheduled'
                          }" *ngIf="col.field !== 'crossConnectId'">
                          <ng-container *ngIf="col.field === 'permissioningId'">
                            <span *ngIf="service === 'QRD' && rowData['layer'] === 'layer3'"
                                  pTooltip="Permissioning Ip : {{ rowData['permissioningIp'] }}" tooltipPosition="top">
                              {{ rowData[col.field] }}
                            </span>
                            <span *ngIf="!(service === 'QRD' && rowData['layer'] === 'layer3')">
                              {{ rowData[col.field] }}
                            </span>
                          </ng-container>
                            <ng-container *ngIf="col.field ==='staticJoinSubnets'">
                                <span [innerHTML]="rowData[col.field]"></span>
                            </ng-container>
                          <ng-container *ngIf="col.field !== 'permissioningId' && col.field !=='staticJoinSubnets'">
                            {{ rowData[col.field] }}
                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-template>
                </p-table>
                  </ng-container>
                  <ng-container *ngIf="service==='QRD' && channelsHaveLayer( tab.channels,'layer3')">
                      <h6>Layer 3</h6>
                      <p-table [columns]="getChannelsColumns(service, 'layer3')" [value]="getLayerlines(tab.channels,'layer3')"
                               [scrollable]="true" scrollHeight="200px">
                          <ng-template let-columns pTemplate="header">
                              <tr>
                                  <th *ngFor="let col of columns" [style.width]="col.width">
                                      {{ col.header }}
                                  </th>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                              <tr *ngIf="rowData.layer === 'layer3'">
                                  <td *ngIf="isFirstOccurrence(rowIndex, rowData.crossConnectId, getLayerlines(tab.channels,'layer3'))"
                                      [attr.rowspan]="calculateRowSpan(rowData.crossConnectId, getLayerlines(tab.channels,'layer3'))"
                                      [style.width]="getColumnWidth(columns, 'crossConnectId')">
                                      {{ rowData.crossConnectId }}
                                  </td>
                                  <ng-container *ngFor="let col of columns">
                                      <td [style.width]="col.width"
                                          [ngClass]="{
                            'text-green': rowData[col.field] === 'Configured',
                            'text-red': rowData[col.field] === 'Deconfigured',
                            'text-yellow': rowData[col.field] === 'Requested' || rowData[col.field] === 'Config scheduled' || rowData[col.field] === 'New',
                            'text-orange': rowData[col.field] === 'Deconfig requested' || rowData[col.field] === 'Deconfig scheduled'
                          }" *ngIf="col.field !== 'crossConnectId'">
                                          <ng-container *ngIf="col.field === 'permissioningId'">
                            <span *ngIf="service === 'QRD' && rowData['layer'] === 'layer3'"
                                  pTooltip="Permissioning Ip : {{ rowData['permissioningIp'] }}" tooltipPosition="top">
                              {{ rowData[col.field] }}
                            </span>
                                              <span *ngIf="!(service === 'QRD' && rowData['layer'] === 'layer3')">
                              {{ rowData[col.field] }}
                            </span>
                                          </ng-container>
                                          <ng-container *ngIf="col.field ==='staticJoinSubnets'">
                                              <span [innerHTML]="rowData[col.field]"></span>
                                          </ng-container>
                                          <ng-container *ngIf="col.field !== 'permissioningId' && col.field !=='staticJoinSubnets' ">
                                              {{ rowData[col.field] }}
                                          </ng-container>
                                      </td>
                                  </ng-container>
                              </tr>
                          </ng-template>
                      </p-table>
                  </ng-container>
                  <ng-container *ngIf="service==='QRD' && channelsHaveLayer( tab.channels,'layer1')">
                      <hr/>
                      <h6>Layer 1</h6>
                      <p-table [columns]="getChannelsColumns(service, 'layer1')" [value]="getLayerlines(tab.channels,'layer1')"
                               [scrollable]="true" scrollHeight="200px">
                          <ng-template let-columns pTemplate="header">
                              <tr>
                                  <th *ngFor="let col of columns" [style.width]="col.width">
                                      {{ col.header }}
                                  </th>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                              <tr *ngIf="rowData.layer === 'layer1'">
                                  <td *ngIf="isFirstOccurrence(rowIndex, rowData.crossConnectId, getLayerlines(tab.channels,'layer1'))"
                                      [attr.rowspan]="calculateRowSpan(rowData.crossConnectId, getLayerlines(tab.channels,'layer1'))"
                                      [style.width]="getColumnWidth(columns, 'crossConnectId')">
                                      {{ rowData.crossConnectId }}
                                  </td>
                                  <ng-container *ngFor="let col of columns">
                                      <td [style.width]="col.width"
                                          [ngClass]="{
                            'text-green': rowData[col.field] === 'Configured',
                            'text-red': rowData[col.field] === 'Deconfigured',
                            'text-yellow': rowData[col.field] === 'Requested' || rowData[col.field] === 'Config scheduled' || rowData[col.field] === 'New',
                            'text-orange': rowData[col.field] === 'Deconfig requested' || rowData[col.field] === 'Deconfig scheduled'
                          }" *ngIf="col.field !== 'crossConnectId'">
                                          <ng-container *ngIf="col.field === 'permissioningId'">
                            <span *ngIf="service === 'QRD' && rowData['layer'] === 'layer3'"
                                  pTooltip="Permissioning Ip : {{ rowData['permissioningIp'] }}" tooltipPosition="top">
                              {{ rowData[col.field] }}
                            </span>
                                              <span *ngIf="!(service === 'QRD' && rowData['layer'] === 'layer3')">
                              {{ rowData[col.field] }}
                            </span>
                                          </ng-container>
                                          <ng-container *ngIf="col.field !== 'permissioningId'">
                                              {{ rowData[col.field] }}
                                          </ng-container>
                                      </td>
                                  </ng-container>
                              </tr>
                          </ng-template>
                      </p-table>
                  </ng-container>
              </div>
              <div *ngIf="tab.histories?.length != 0" class="mt-2">
                <p class="item-info">Service history</p>
                <p-table [columns]="historiesCols" [scrollable]="true" [value]="tab.histories" scrollHeight="200px">
                  <ng-template let-columns pTemplate="header">
                    <tr>
                      <th *ngFor="let col of columns" [style.width]="col.width">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-columns="columns" let-rowData pTemplate="body">
                    <tr>
                      <td *ngFor="let col of columns" [style.width]="col.width">
                        {{ rowData[col.field] }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabPanel>
          </p-tabView>
        </p-overlayPanel>
      </div>
    </div>
  </div>
</div>
<p-overlayPanel #legendPanel [dismissable]="true" appendTo="body" styleClass="legend">
  <div class="legend-section">
    <div class="legend-section-title">Letters / Colors</div>
    <ul class="legend-list">
      <li><span class="icon icon-green"></span><span class="legend-label">C / Green: active service</span></li>
      <li><span class="icon icon-grey"></span><span class="legend-label">D / Grey: terminated service</span></li>
      <li><span class="icon icon-yellow"></span><span class="legend-label">N / Yellow: new service</span></li>
    </ul>
  </div>
  <div class="legend-section">
    <div class="legend-section-title">Icons</div>
    <ul class="legend-list">
      <li><span class="icon icon-rf"></span><span class="legend-label">RF - Radio Frequency</span></li>
      <li><span class="icon icon-arbitrated"></span><span class="legend-label">Arbitration</span></li>
      <li><span class="icon icon-protected"></span><span class="legend-label">Protected</span></li>
      <li><span class="icon icon-encrypted"></span><span class="legend-label">Encrypted</span></li>
      <li><span class="icon icon-sfi"></span><span class="legend-label">Streaming Frame Interface</span></li>
      <li><span class="icon icon-encrypted-protected"></span><span class="legend-label">Protected and Encrypted</span></li>
      <li class="legend-divider"><span class="icon fa fa-exclamation-circle"></span><span class="legend-label">Ongoing outage</span></li>
      <li><span class="icon fa fa-question-circle"></span><span class="legend-label">Ongoing announcement</span></li>
      <li><span class="icon fa fa-file"></span><span class="legend-label">Multiple feeds/carriers</span></li>
    </ul>
  </div>
</p-overlayPanel>
<p-dialog [(visible)]="isJirapopUp"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'auto','max-width': '80vw',
                           'max-height': '80vh','min-height':'300px'}"
          [draggable]="false"
          [maximizable]="true"
          [modal]="true"
          [resizable]="true">
  <ng-template pTemplate="header">
    <div class="row">
      <div class="col-md-2">
        <img alt="" class="jira-logo" src="../../../assets/images/logo-jira.png">
      </div>
      <div class="col-md-10 jira-header">
        Create a new Jira issue
      </div>
    </div>
  </ng-template>
  <div class="jira-body">
    <div class="modal-body">
      <p *ngIf="isSendToJiraDisabled"><label class="required-items-alert"> Please fill in all required fields</label>
      </p>
      <label *ngIf="loggedInUser" class="custom-label  mb-2">Reporter: {{ loggedInUser.username }}</label>
      <label *ngIf="jiraIssue.subject" class="custom-label mt-2 mb-2"> Subject: {{ jiraIssue.subject }}</label>
      <label class="jira-text">Items:</label>
      <p-group-multiselect (selectedOptionsEvent)="fillSelectedItems($event)"
                           [options]="itemsDropDownOptions"
                           [inputWidth]="'100%'"
                           [filter]="true"
                           [selectedItemsLabel]="'Select items'">
      </p-group-multiselect>
      <div *ngIf="channelsDropDownList.length!=0">
        <label class="jira-text">Channels:</label>
        <p-group-multiselect (selectedOptionsEvent)="fillSelectedChannel($event)"
                             [options]="channelsDropDownOptions"
                             [inputWidth]="'100%'"
                             [filter]="true"
                             filterBy="label"
                             [selectedItemsLabel]="'Select channel'">
        </p-group-multiselect>
      </div>
      <label class="jira-text mt-2" for="priority">Priority:</label>
      <select [(ngModel)]="selectedPriority" class="p-dropdown with-icons" id="priority" name="priority">
        <option data-icon="fas fa-life-ring" value="support">Support</option>
        <option data-icon="fas fa-exclamation-triangle" value="urgent">Urgent</option>
      </select>
      <div *roles="['ROLE_CLIENT']" class="mt-2">
        <label class="jira-text">Request participants:</label>
        <p-multiSelect
          [(ngModel)]="selectedParticipantForJira"
          [filter]="true"
          [options]="participantsItemForJira"
          [panelStyle]="{'width':'95em'}"
          [placeholder]="'Select Participants'"
          [style]="{'width':'95em'}"
          class="p-multiSelect"
          required>
        </p-multiSelect>
      </div>
      <label class="custom-label mt-2" for="description">Describe the issue:</label>
      <p-editor (onTextChange)="setIsSendToJiraFlag()" [(ngModel)]="jiraCustomDescription" [style]="{ height: '80px' }"
                id="description" name="description" placeholder="Enter the description"></p-editor>
    </div>
    <div style="display: flex; justify-content: flex-end; align-items: center; margin-top: 1rem;">
      <button (click)="createIssue()" [disabled]=isSendToJiraDisabled class="create-button"  appNoDblClick>Send to JIRA</button>
      <button (click)="cancel()" class="cancel-button">Cancel</button>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="displayMulticastDialog" [draggable]="false" [modal]="true" [resizable]="false"
          [style]="{width: '560px'}" header="Multicast Groups" styleClass="qed-multicast-dialog">
  <div *ngIf="!hasMulticasts('New') && !hasMulticasts('Accepted')" class="multicast-empty">
    <i class="fa fa-info-circle"></i> No multicasts available.
  </div>
  <div *ngFor="let status of ['New', 'Accepted']">
    <div *ngIf="hasMulticasts(status)" class="status-section">
      <div class="status-header">
        <span [ngClass]="'status-badge--' + status.toLowerCase()" class="status-badge">{{ status }}</span>
        <button (click)="copyMulticasts(status)"
                [icon]="copiedStatus === status ? 'fa fa-check' : 'fa fa-copy'"
                [label]="copiedStatus === status ? 'Copied' : 'Copy'"
                [ngClass]="{'copy-button--copied': copiedStatus === status}"
                class="copy-button" iconPos="left" pButton type="button"></button>
      </div>
      <div *ngFor="let xcoId of Object.keys(multicastGroups[status])" class="xco-group">
        <div class="xco-id">{{ xcoId }}</div>
        <ul class="multicast-list">
          <li *ngFor="let multicast of multicastGroups[status][xcoId]">
            {{ multicast }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showConfigPopup" [draggable]="false" [modal]="true" [resizable]="false"
          [style]="{width: '720px'}" header="POP Configuration" styleClass="qed-pop-config-dialog">
  <div *ngIf="loadingConfigs" class="pop-config-empty">
    <i class="fa fa-spinner fa-spin"></i> Loading your configuration...
  </div>
  <div *ngIf="!loadingConfigs && configsFailed" class="pop-config-empty">
    <i class="fa fa-exclamation-circle"></i> Your configuration could not be loaded. Please try again.
  </div>
  <div *ngIf="!loadingConfigs && !configsFailed && configsByPop.length === 0" class="pop-config-empty">
    <i class="fa fa-info-circle"></i> No POP configuration available for this service.
  </div>

  <div *ngFor="let pop of configsByPop" class="pop-section">
    <div class="pop-header">
      <span class="pop-name">{{ pop.commercialPopName || pop.technicalPopName || 'Unknown POP' }}</span>
      <span class="pop-count">{{ pop.configurations.length }}
        {{ pop.configurations.length === 1 ? 'connection' : 'connections' }}</span>
    </div>

    <div *ngFor="let config of pop.configurations" class="config-card">
      <div class="config-card-header">
        <span class="config-connection">{{ connectionName(config) }}</span>
        <div class="config-card-actions">
          <span *ngIf="config.updatedAt" class="config-updated">Updated {{ config.updatedAt | date:'dd MMM yyyy' }}</span>
          <button *ngIf="config.currentConfig" (click)="copyConfig(config)"
                  [icon]="copiedId === config.configId ? 'fa fa-check' : 'fa fa-copy'"
                  [label]="copiedId === config.configId ? 'Copied' : 'Copy'"
                  [ngClass]="{'copy-button--copied': copiedId === config.configId}"
                  class="copy-button" iconPos="left" pButton type="button"></button>
        </div>
      </div>
      <pre *ngIf="config.currentConfig" class="config-text">{{ config.currentConfig }}</pre>
      <div *ngIf="!config.currentConfig" class="config-not-applied">
        <i class="fa fa-info-circle"></i> No configuration applied yet.
      </div>

      <div *ngIf="config.targetConfig" class="target-config">
        <button (click)="toggleTargetConfig(config)"
                [icon]="expandedTargetId === config.configId ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
                [label]="expandedTargetId === config.configId ? 'Hide target configuration' : 'View target configuration'"
                class="target-toggle" iconPos="left" pButton type="button"></button>

        <div *ngIf="expandedTargetId === config.configId" class="target-config-body">
          <div class="target-config-header">
            <span class="target-config-title">Target configuration</span>
            <button (click)="copyTargetConfig(config)"
                    [icon]="copiedId === targetConfigId(config) ? 'fa fa-check' : 'fa fa-copy'"
                    [label]="copiedId === targetConfigId(config) ? 'Copied' : 'Copy'"
                    [ngClass]="{'copy-button--copied': copiedId === targetConfigId(config)}"
                    class="copy-button" iconPos="left" pButton type="button"></button>
          </div>
          <pre class="config-text">{{ config.targetConfig }}</pre>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
